module.exports = __webpack_public_path__ + "img/太平洋@2x.2410e5b5.png";